import React from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '../../../lib/utils';

export interface TaskyEmptyStateProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

export const TaskyEmptyState: React.FC<TaskyEmptyStateProps> = ({
  className,
  icon,
  title,
  description,
  action,
  ...rest
}) => (
  <div
    {...rest}
    className={cn(
      'bg-white rounded-tasky-md border border-warm-border p-8 text-center max-w-md mx-auto',
      className,
    )}
  >
    <div className="mx-auto mb-4 text-gray-300 [&_svg]:size-16 flex justify-center">
      {icon ?? <Inbox />}
    </div>
    <h4 className="text-lg font-semibold text-dark mb-1">{title}</h4>
    {description && <p className="text-sm text-gray-500 mb-4">{description}</p>}
    {action && <div className="flex justify-center">{action}</div>}
  </div>
);
